import { faCircleInfo } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popup } from "@progress/kendo-react-popup";
import { useRef, useState } from "react";

export const TooltipPopupIcon = ({ content }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const anchor = useRef(null);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowTooltip(false);
    }, 100);
  };

  const modifyLinks = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");

    const links = doc.querySelectorAll("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });

    return doc.body.innerHTML;
  };

  const processedContent = modifyLinks(String(content));

  return (
    <>
      <div
        ref={anchor}
        style={{ display: "inline-block" }}
      >
        <FontAwesomeIcon
          icon={faCircleInfo}
          style={{
            "--fa-primary-color": "var(--atlas-text-secondary)",
            "--fa-secondary-color": "var(--atlas-text-muted)",
            cursor: "pointer",
            fontSize: "16px",
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </div>
      <Popup
        anchor={anchor.current}
        show={showTooltip}
        popupClass="custom-tooltip-popup"
      >
        <div
          style={{
            padding: "10px",
            backgroundColor: "var(--atlas-bg-primary)",
            border: "1px solid var(--atlas-border-color)",
            borderRadius: "4px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            color: "var(--atlas-text-primary)",
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div dangerouslySetInnerHTML={{ __html: processedContent }} />
        </div>
      </Popup>
    </>
  );
};
